import { rgba } from 'polished';
import { Box } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const BannerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: theme.spacing(2),
  padding: theme.spacing(3.5, 6),
  backgroundColor: rgba(theme.palette.primary.main, 0.2),
  borderRadius: theme.customShape.borderRadius2XL,
  width: '100%',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(4.5, 6),
  },
}));
